import React, { useEffect, useState, useRef } from "react";
import { Loading } from "../../../components/Loading/Loading";
import { Toast } from "primereact/toast";
import { dataUserSession, ipAddressSession } from "../../../utilities/dataSession";
import { formatDateAPI } from "../../../utilities/DateUtil";
import { useHistory } from "react-router-dom";
import { DialogOpenReport } from "../../../components/DialogService/DialogService";
import DialogGenReport from "../../../components/DialogReport/DialogGenReport";


import P100Overview from "./P100Overview";
import P100List from "./P100List";

import { P100Dashboard, P100GetDataList } from "../../../service/100/P100Service";
import P101 from "../101/P101";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { onGetRequestPrint, onGetRequestResultPrint } from "../../../Report/114/RPT114CallService";

//Report
import { pdfRPT114 } from "../../../Report/114/RPT114PDF";
import { wordRPT114 } from "../../../Report/114/RPT114Word";

export default function P100() {
    const history = useHistory();
    const toast = useRef(null);
    const [dialog, setDialog] = useState({ dialog: false, action: "" });
    const [errData, setErrData] = useState(null);

    //Dashboard
    const [dataDashboard, setDataDashboard] = useState({
        alarmPendingOrder: "",
        alarmPendingRequest: "",
        alarmUnreportRequest: "",
        totalContract: "-",
        totalPendingOrder: "-",
        totalPendingRequest: "-",
        totalUnreportRequest: "-",
    });

    const [sentDashBoard, setSentDashBoard] = useState({
        mode: "U",
        sessionId: ipAddressSession() ? ipAddressSession().sessionId : "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    //DataTable
    const [dataTable, setDataTable] = useState([]);
    const [searchData, setSearchData] = useState({
        // new
        inquireMode: "A",
        contractNo: "",
        requestDateBegin: "",
        requestDateEnd: "",
        requestStatus: "",
        requestType: "",
        searchWord: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
        ...(history.location.state && history.location.state.dataSrh ? history.location.state.dataSrh : ""),
    });

    const [fullName] = useState(dataUserSession() ? dataUserSession().userFullName : "");
    const [loading, setLoading] = useState(false);
    const [loadingRefresh, setLoadingRefresh] = useState(false);

    // Report
    const [dialogPDF, setDialogPDF] = useState(false);
    const [dialogReport, setDialogReport] = useState({ dialog: false, show: false });
    const [dataRPTPrint, setDataRPTPrint] = useState([]);
    const [dataRPTResultPrint, setDataRPTResultPrint] = useState([]);
    const [countTimer, setcountTimer] = useState(30);

    const onP100Dashboard = () => {
        setLoadingRefresh(true);
        P100Dashboard(sentDashBoard).then(
            (res) => {
                setLoadingRefresh(false);
                // console.log(res)
                if (res !== undefined) {
                    if (res[0]) {
                        setDataDashboard(res[0]);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoadingRefresh(false);
                setErrData(err);
            }
        );
    };

    const onP100GetDataList = async () => {
        setLoading(true);
        let dataSrh = {
            ...searchData,
            requestNo: searchData.contractNo,
            requestDateBegin: searchData.requestDateBegin !== "" ? formatDateAPI(searchData.requestDateBegin, false) : "",
            requestDateEnd: searchData.requestDateEnd !== "" ? formatDateAPI(searchData.requestDateEnd, false) : "",
        };
        // console.log(dataSrh);
        await P100GetDataList(dataSrh).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    useEffect(() => {
        if (dataUserSession()) {
            // if (history.location.state && history.location.state.dataSrh) {
            //     setSearchData({
            //         ...searchData,
            //         ...history.location.state.dataSrh,
            //     });
            // }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onP100GetDataList();
    }, [searchData]);

    useEffect(() => {
        onP100Dashboard();
    }, [sentDashBoard]);

    useEffect(() => {
        let count = 30;
        const interval = setInterval(() => {
            // sentDashBoard.mode ='A'
            if (count === 1) {
                setSentDashBoard({
                    ...sentDashBoard,
                    mode: "A",
                });
                onP100GetDataList();
                count = 30;
                setcountTimer(30);
            } else {
                count = count - 1;
                setcountTimer(count);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [searchData, sentDashBoard]);

    const onRefreshClick = () => {
        setSentDashBoard({
            ...sentDashBoard,
            mode: "A",
        });
        onP100GetDataList();
        setcountTimer(30);
    };

    const onClickPendingOrder = () => {
        setSearchData({
            ...searchData,
            // "contractNo": "",
            // "requestDateBegin": "",
            // "requestDateEnd": "",
            requestStatus: "G",
            // "requestType": "",
            // "searchWord": "",
        });
    };

    const onClickPendingRequest = () => {
        setSearchData({
            ...searchData,
            requestStatus: "F",
        });
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const goPage = (data) => {
        if (data.functionId === "120") {
            history.push({ pathname: data.functionId, state: { requestNo: data.requestNo } });
        } else {
            history.push({
                pathname: data.functionId ? data.functionId : "/",
                state: {
                    action: data.requestNo ? "EDIT" : "NEW",
                    form: "100",
                    requestNo: data.requestNo,
                    requestType: data.requestType,
                    requestTypeDesc: data.requestTypeDesc,
                    contractNo: data.contractNo,
                },
            });
        }
    };

    const onExport = (act) => {
        switch (act) {
            case "PDF":
                pdfRPT114(dataRPTPrint, dataRPTResultPrint, setLoading, setDialogPDF);
                break;

            case "WORD":
                wordRPT114(dataRPTPrint, dataRPTResultPrint, setLoading);
                break;

            default:
                break;
        }
        setDialogReport({ dialog: false, show: false });
    };

    const handlerReport = (requestNo) => {
        const req = {
            requestNo: requestNo,
            userId: searchData.userId,
        };
        onGetRequestPrint(setLoading, req, setDataRPTPrint, toast);
        onGetRequestResultPrint(setLoading, req, setDataRPTResultPrint, toast);

        setDialogReport({ dialog: true, show: false });
    };

    const handlerNewBill = () => {
        history.push({
            pathname: "102",
            state: {
                requestType: "1",
                action: "บันทึก",
                form: "101",
            },
        });
    };

    // console.log(dataTable);

    

    return (
        <>
             <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            {/* <div className="p-grid crud-demo"> */}
            <Toast ref={toast} position="top-right" />
            <br />
            <div className="grid">
                {/* <Chip label={" ผู้รับเหมา : " + fullName} icon="pi pi-user" className="p-mr-2 p-mb-2" style={{ fontSize: "1.5rem" }} /> */}
                <P100Overview dataDashboard={dataDashboard} onClickPendingOrder={onClickPendingOrder} onClickPendingRequest={onClickPendingRequest} countTimer={countTimer} onRefreshClick={onRefreshClick} loadingRefresh={loadingRefresh} />
            </div>
            <br />

            <div className="card">
                {/* <P100List dataTable={dataTable} searchData={searchData} goPage={goPage} setDialog={setDialog} setHandlerReport={handlerReport} /> */}
                <P100List dataTable={dataTable} searchData={searchData} goPage={goPage} newBill={handlerNewBill} setHandlerReport={handlerReport} setLoading={setLoading} setErrData={setErrData} showMessages={showMessages} userId={dataUserSession() ? dataUserSession().userId : ""}/>
            </div>
            <P101 dialog={dialog} setDialog={setDialog} showMessages={showMessages} />
            {/* </div> */}
            <DialogGenReport dialog={dialogReport} setDialog={setDialogReport} setExport={onExport} pdf={true} word={true} setHeader="พิมพ์ใบแจ้งฯ และรายงานผลงานประจำวัน" />
            <DialogOpenReport header="พิมพ์ใบแจ้งฯ และรายงานผลงานประจำวัน" dialog={dialogPDF} setDialog={setDialogPDF} />
        </>
    );
}
